import { getAuth, signOut } from "firebase/auth";

// -------------------------------------------------------
// -------------------------------------------------------
export const signin = (user) => async (dispatch) => {
  dispatch({
    type: "SET_USER",
    email: user.email,
    uid: user.uid,
  });
};

// -------------------------------------------------------
// -------------------------------------------------------
export const signout = () => (dispatch) => {
  dispatch({ type: "SET_USER", uid: null, email: null });
  const auth = getAuth();
  signOut(auth);
};

// -------------------------------------------------------
// -------------------------------------------------------
export const notify = (content, duration) => async (dispatch) => {
  dispatch({ type: "SET_NOTIFICATION", notification: content });
  await new Promise((resolve) => setTimeout(resolve, duration));
  dispatch({ type: "SET_NOTIFICATION", notification: null });
};